<template>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
          <v-card-title class="primary white--text title">
              User
          </v-card-title>
          <v-card-text>
              <v-text-field label="Email" autofocus v-model="activeItem.email" :disabled="!$can('update','Users')"></v-text-field>
              <v-text-field label="User Name" autofocus v-model="activeItem.user_name" :disabled="!$can('update', 'Users')"></v-text-field>
              <v-text-field label="Updated On" autofocus v-model="activeItem.updated_on" disabled></v-text-field>
              <v-text-field label="Created On" autofocus v-model="activeItem.created_on" disabled></v-text-field>
              <v-select :items="roles"
                      label="Role"
                      v-model="activeItem.role"
                      :disabled="!$can('update', 'Users')"
              ></v-select>
              <v-switch v-model="isChangePassword" label="Change password?"></v-switch>
              <v-text-field label="Password" v-model="activeItem.password" :type="'password'" v-if="isChangePassword"></v-text-field>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord(true)">Save</v-btn>
              <v-btn @click="initializeVar(true)">Cancel</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {putUser} from '../../helper'

  export default {
    components: { },
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null},
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
        }
      },
      value () {
        if (!this.activeItem.user_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        isChangePassword: false,
        dialog: false,
          roles:[
              {
                  text:'Administrator',
                  value:'admin'
              },
              {
                  text:'Maintainer',
                  value:'maintainer'
              },
              {
                  text:'Operator',
                  value:'operator'
              }
          ],
          activeItem: {
          user_id: null,
          email: '',
          user_name: '',
          updated_on:  '',
          created_on: '',
          role: '',
          password: ''

        } ,

      }
    },
    methods: {
      initializeVar(close) {
        this.activeItem = {
          user_id: null,
          email: '',
          user_name: '',
          updated_on:  '',
          created_on: '',
          role: '',
          password: ''
          }
          if(close) {
              this.dialog = false;
          }
      },
      async addRecord (close) {
        await putUser(
          {
            'user_id': this.activeItem.user_id,
            'email': this.activeItem.email,
            'user_name': this.activeItem.user_name,
            'updated_on': this.activeItem.updated_on,
            'created_on': this.activeItem.created_on,
            'role': this.activeItem.role,
            'password': (this.isChangePassword)?this.activeItem.password:'',
          }
        )
          this.$emit('updatedusers', this.dialog)
          if(close) {
              this.dialog = false;
          }
      }
    },
    name: 'UserRecordDialog'
  }
</script>

<style scoped>

</style>
